
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _400nXinuWCnwbXaZs5Fxd8Bvo9FzXLNT1W9v0jTQlMR5RIMeta } from "/opt/build/repo/domains/core/pages/400.vue?macro=true";
import { default as _4014ArVz3GTOhpBztB4wIj7ToKB2D89motj214kE49_JLwMeta } from "/opt/build/repo/domains/core/pages/401.vue?macro=true";
import { default as _4032bwS6BTmJW_45SahbMB7cNEY1bIvHb7m8Qum5v77Qe1w0Meta } from "/opt/build/repo/domains/core/pages/403.vue?macro=true";
import { default as _404FkvJYN2RR2_DK1I6DUQ7N7pM8KJl0dY5VeySMLfPtAEMeta } from "/opt/build/repo/domains/core/pages/404.vue?macro=true";
import { default as _500xF7TE5f1siBnPEZIyZ5iugifPB2Zl3jioKBLFZ69yOsMeta } from "/opt/build/repo/domains/core/pages/500.vue?macro=true";
import { default as cartijX6008voCsjRaXrjozoJMBR24DaJtq4HBokuQXJlTsMeta } from "/opt/build/repo/domains/commerce/pages/cart.vue?macro=true";
import { default as index7mIea3qh1PlVb4QKSTZbaesVuWKGVqBS0SUG6KpT_45FoMeta } from "/opt/build/repo/domains/commerce/pages/help/index.vue?macro=true";
import { default as all_45topicsvRuvM99ruYTyVKp_vFCObRsYTg8b9cRhmy5UWx2kzxsMeta } from "/opt/build/repo/domains/commerce/pages/help/all-topics.vue?macro=true";
import { default as contact_45usqSRckMeDE33LsgLiz8AM_DtrAlfM_45zyR_maoi8xhRnQMeta } from "/opt/build/repo/domains/commerce/pages/help/contact-us.vue?macro=true";
import { default as size_45charteoWzQJd8ZTCfu7K7BAxyflZMSS86oTlH_ICoQs8WwOwMeta } from "/opt/build/repo/brands/timberland/pages/help/size-chart.vue?macro=true";
import { default as size_45charts3KQkLy5uEcxVxCwRq1wFd8eL44fEla7izo6nvZyjXc4Meta } from "/opt/build/repo/domains/commerce/pages/help/size-charts.vue?macro=true";
import { default as index_45Ozbnrjx_S3U_45qm5prUuvnUat9SJ7QVpU9IanjO95_sMeta } from "/opt/build/repo/domains/commerce/pages/help/[slug]/index.vue?macro=true";
import { default as indexcro7bVMs9gKA35N0ihDM5eJP2DXwLAd2e4tbxuTSYEwMeta } from "/opt/build/repo/domains/commerce/pages/help/[slug]/[child_slug]/index.vue?macro=true";
import { default as _91slug_93EFq6TQbERTdh4910qlRWp1h7TO2JQDYUH8WX8QB46RkMeta } from "/opt/build/repo/brands/timberland/pages/help/promotions-and-discounts/[slug].vue?macro=true";
import { default as helpYI9Aj03_45GBus75FoIdry2HO3IzfvJCigBUfYzlPr7GEMeta } from "/opt/build/repo/domains/commerce/pages/help.vue?macro=true";
import { default as indexRxbhi3LU3GDDPAR9_45HKIRzgNgrgFbIB_452Dooq_45hA69cMeta } from "/opt/build/repo/domains/commerce/pages/search/index.vue?macro=true";
import { default as articlesU3f3HsiLilRr7HfOFYCCGZKw2icYjpwWas3PoXnMPzAMeta } from "/opt/build/repo/domains/commerce/pages/search/articles.vue?macro=true";
import { default as searchRO4tzUI4tmQBu_aNiG_tC0A3rxzZdSwXd5dYKSaVXWkMeta } from "/opt/build/repo/domains/commerce/pages/search.vue?macro=true";
import { default as stores6zCHEAcfUFh1Xcvq2vFVkG0vnR_LAooAnKj_45Koi9u64Meta } from "/opt/build/repo/brands/timberland/pages/stores.vue?macro=true";
import { default as indexhiDGsdtSRHe2vqICrY_C72_T3t9PXh17y_453qDDQVSkAMeta } from "/opt/build/repo/domains/commerce/pages/account/index.vue?macro=true";
import { default as loyalty3wNgiXUTZcRzY6wOPRzn7Jb9JINQ7TWnPl3GaMZCwIMMeta } from "/opt/build/repo/domains/commerce/pages/account/loyalty.vue?macro=true";
import { default as profilensxEhguA_WrIl6Feo5MtRQsp4n7gkf2ZhDSSOPc_45uEsMeta } from "/opt/build/repo/domains/commerce/pages/account/profile.vue?macro=true";
import { default as gift_45cardspwqYZSwO3HvJ5J_45g8C_yx9p3XU_49Tqr9444vNTfDjUMeta } from "/opt/build/repo/domains/commerce/pages/account/gift-cards.vue?macro=true";
import { default as indexG4bEWsxomlrMoXHZrwmechQEtcW0uYVIlfY7raPPpFAMeta } from "/opt/build/repo/domains/commerce/pages/account/address/index.vue?macro=true";
import { default as order_45historyn0rHoVGIMKe8lFacDQN_IJbKqRgzXUbwHX_45SpjTllMIMeta } from "/opt/build/repo/domains/commerce/pages/account/order-history.vue?macro=true";
import { default as addWedzaMZiySLZIG4sxQ5UBSoLlkUBTZMmb_45ku6UOmJ54Meta } from "/opt/build/repo/domains/commerce/pages/account/credit-cards/add.vue?macro=true";
import { default as indexTKl2R4M2EWtMECFcOG4z6dH3nE90_JnSE9uLumN4pzAMeta } from "/opt/build/repo/domains/commerce/pages/account/credit-cards/index.vue?macro=true";
import { default as _91_46_46_46id_93nJh8mAEyj0vyqA5yWL2OKjERt1pZ9RxjcUqH_sHSsa0Meta } from "/opt/build/repo/domains/commerce/pages/account/order-details/[...id].vue?macro=true";
import { default as add_45billing_45address8kfEdc6QJE8Q3nb9nr69CiAo34ALO4dMKLlRfnPo_60Meta } from "/opt/build/repo/domains/commerce/pages/account/address/add-billing-address.vue?macro=true";
import { default as add_45shipping_45addressrmVdSgo4lNpctayrCpkqLftE_45XxOxr1yKDXZiB16qk8Meta } from "/opt/build/repo/domains/commerce/pages/account/address/add-shipping-address.vue?macro=true";
import { default as account_3j_45mcRuyGg7FTgtN0KIkS4xk9Jg96vrgdYuKT1i2F0Meta } from "/opt/build/repo/domains/commerce/pages/account.vue?macro=true";
import { default as sign_45inU9qLdxmychjW0749cQjyNd9nXpwrQ_wZcKzTpjldOiEMeta } from "/opt/build/repo/domains/commerce/pages/sign-in.vue?macro=true";
import { default as about_45usFO13yBW4aNkWTIXh5VJ46AmPaT0mcflSOJFG_d1beCEMeta } from "/opt/build/repo/brands/timberland/pages/about-us.vue?macro=true";
import { default as checkout6zqv22aNu9BrG1dChQCj_455IH2kgAKnLezPye0Kugxm8Meta } from "/opt/build/repo/domains/commerce/pages/checkout.vue?macro=true";
import { default as _91_46_46_46slug_93CrMFLkWbvVSiu0B9By5os_RsavVX2AgsroDUT_45TVRYwMeta } from "/opt/build/repo/domains/content/pages/[...slug].vue?macro=true";
import { default as favoritesONyPSTVmnbSJpmPYRXJidDor1wJSa4PwH2IkuggGxakMeta } from "/opt/build/repo/domains/commerce/pages/favorites.vue?macro=true";
import { default as gift_45cardWnAIjMVwSqjNmrWtwfJDVWPepjV3RLWLQoeinbs6a2oMeta } from "/opt/build/repo/domains/commerce/pages/gift-card.vue?macro=true";
import { default as az_45contestwuVAFWdM7CyzPi67ebFCx2hdYN_45ZAk0jr3wBvg4_45QE4Meta } from "/opt/build/repo/brands/timberland/regions/emea/pages/az-contest.vue?macro=true";
import { default as contact_45ussqqBRJIAHerGh_45KecsqFDVOGMySIJOTbFT1f_455zA6IIMeta } from "/opt/build/repo/brands/timberland/pages/contact-us.vue?macro=true";
import { default as lower_45envsGva5dXm0sUdFEmvA3dbTcKFaQbJLUXZxYspbheLHck4Meta } from "/opt/build/repo/domains/core/pages/lower-envs.vue?macro=true";
import { default as size_45chartzkbOxfBx4qP_5TQivfBEla1g1Kz10ko2RWF6n5dcyssMeta } from "/opt/build/repo/domains/commerce/pages/size-chart.vue?macro=true";
import { default as frame1aSq_45MaS2HDfGNywXSkE_45CmCw_iZYPBIGgqFcUaenCsMeta } from "/opt/build/repo/domains/commerce/pages/soci/frame.vue?macro=true";
import { default as _91_46_46_46slug_93EbK_vwv_l52SPLMC0fpbEeQDmT7O6fnDpyfDb6dFsqcMeta } from "/opt/build/repo/domains/commerce/pages/c/[...slug].vue?macro=true";
import { default as previewgT0SgvGgzxM32iVtPDlGsYEeL2DkQDkQKXFfkb64mgAMeta } from "/opt/build/repo/domains/content/pages/cms/preview.vue?macro=true";
import { default as _91_46_46_46slug_93hvFeJOqywUBgr7IArn1oZje2ymA3AfCwFnqxkta1HwsMeta } from "/opt/build/repo/domains/brands/pages/o/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93sS_evXxzVeC_459iV85ESlWiWgprFUbbxSDUpIql4S_KsMeta } from "/opt/build/repo/domains/commerce/pages/p/[...slug].vue?macro=true";
import { default as footerX44fL7pRNXwlmfhOZtBOvJUrLf94cvbG2VCFt6KjR94Meta } from "/opt/build/repo/domains/commerce/pages/soci/footer.vue?macro=true";
import { default as headerd3qY4igJYSD2pbxrvQmLpl7TfwNc5AQgrLVokWMCE1cMeta } from "/opt/build/repo/domains/commerce/pages/soci/header.vue?macro=true";
import { default as get_45the_45lookykCN2BiY6yIBgaXmlgZV9x94OIypwwyJlxcRkK7omuUMeta } from "/opt/build/repo/brands/timberland/pages/get-the-look.vue?macro=true";
import { default as order_45statuseng1bXoqVdZnkohFGOT_ZRQ_45Aunrz5i1gsBnoReHjvsMeta } from "/opt/build/repo/domains/commerce/pages/order-status.vue?macro=true";
import { default as return_45labelOejPaVcBEY8HeKLKvU94gqJgABWmpfQ4l1B6O7gP2ZEMeta } from "/opt/build/repo/domains/commerce/pages/return-label.vue?macro=true";
import { default as agent_45resultsb7_45bqM4TqVCtAe8u2b0Gzmimq_45PkB3_45mHgEixcE0MNMMeta } from "/opt/build/repo/domains/commerce/pages/agent-results.vue?macro=true";
import { default as order_45detailsqZnQ8UGlraBim57iOR6Wi_L8uIHbpaKm_HubgRf7JZgMeta } from "/opt/build/repo/domains/commerce/pages/order-details.vue?macro=true";
import { default as store_45locatorfbrq3Wd1WulVeEpmn_y4mD3iic0hpxoU7u_aGgNDSroMeta } from "/opt/build/repo/domains/commerce/pages/store-locator.vue?macro=true";
import { default as amazon_45sign_45in0_hypGUbXCFbpT45MYvEjUGMLXKF8aC5ws16o7Ao5eEMeta } from "/opt/build/repo/domains/commerce/pages/amazon-sign-in.vue?macro=true";
import { default as reset_45password5V_454JzMUKSBahZIhy5iJTFfwBZCQEB9BJhWbfpKatwoMeta } from "/opt/build/repo/domains/commerce/pages/reset-password.vue?macro=true";
import { default as social_45sign_45inNbReRTvQAi_45gceRen0yRFWFrGnUK5zz8_45_45auA7LmtiEMeta } from "/opt/build/repo/domains/commerce/pages/social-sign-in.vue?macro=true";
import { default as write_45a_45review1y8sosMpLbcS8Q9CYsTVx0SXLV2EfFLjr0hLzj7BenAMeta } from "/opt/build/repo/domains/commerce/pages/write-a-review.vue?macro=true";
import { default as _91slug_93y49ZUZFzrU66JoQ5dZaf_IkUQkH9_728j6_B_i3M_45jEMeta } from "/opt/build/repo/domains/commerce/pages/articles/[slug].vue?macro=true";
import { default as forgot_45passwordZVSP4Gj80jzBVxmWiK43LwinAZ07Mpk4axaYbgLk9_45MMeta } from "/opt/build/repo/domains/commerce/pages/forgot-password.vue?macro=true";
import { default as indexV4B9eX1cl5cKvRem_cAEF2CKVG8CUHA9VFoQ_3xcL_UMeta } from "/opt/build/repo/domains/core/pages/healthcheck/index.vue?macro=true";
import { default as mocksZVKZB7WOQCI_jPUqDbeA6yfCjux2UADwAFNk8M1FjdwMeta } from "/opt/build/repo/domains/core/pages/healthcheck/mocks.vue?macro=true";
import { default as location_45selectoruqLqoewvfbQiJh3XlRldlZt7EdDCHIWNDCuDY11AoYwMeta } from "/opt/build/repo/domains/commerce/pages/location-selector.vue?macro=true";
import { default as _91id_930DijVQgHndtsgh_9PtH80pmmwsNEAp0Y5wn_LJGedBgMeta } from "/opt/build/repo/domains/core/pages/payment-link/[id].vue?macro=true";
import { default as indexGAafnNS1rzieX5FAoLiKdvwrdGFOmh4nHfaGw2sNaTUMeta } from "/opt/build/repo/domains/content/pages/sandbox/cms/index.vue?macro=true";
import { default as splitCZmeTn22XMqu8E3XE1btCyKFraULprQk5lP2eftDHjIMeta } from "/opt/build/repo/domains/content/pages/cms/showcase/split.vue?macro=true";
import { default as _91slug_93DDK2a1jRUHm_45em8bI4LYoXNkyWx0PSY45WuiOV8d5hsMeta } from "/opt/build/repo/brands/timberland/pages/collections/[slug].vue?macro=true";
import { default as statuszrHGVQBp0KWb_dV15we2P3SeZPQdpeTG3iVki8CBfF4Meta } from "/opt/build/repo/domains/core/pages/healthcheck/status.vue?macro=true";
import { default as order_45confirmationLAOHCUh_457ZAaowyQA723r4zI5jIYIqmcl0XAb3TXD9kMeta } from "/opt/build/repo/domains/commerce/pages/order-confirmation.vue?macro=true";
import { default as singlekivaXphvI_45xjWtJXWb8EP6_45kyuhXQhiG9mZgvZcVHJkMeta } from "/opt/build/repo/domains/content/pages/cms/showcase/single.vue?macro=true";
import { default as viewerEq2MpXIuVkPkNABg4b64rG7cmF3Zb3XdR3OBFi3ZG6kMeta } from "/opt/build/repo/domains/content/pages/cms/showcase/viewer.vue?macro=true";
import { default as product_45ingredientsfuVRejwA4C98jhWB_iEwignoYkkmsKYruLi_45mLfmAdQMeta } from "/opt/build/repo/brands/timberland/pages/product-ingredients.vue?macro=true";
import { default as _91productId_93Zae_kquWzBWBEcyvwNdI1L41FELno9Qd7gD890BhSuMMeta } from "/opt/build/repo/domains/commerce/pages/reviews/[productId].vue?macro=true";
import { default as footerWxAjF2RgXBmZph4sum5AiHuMiXB6_mfvISnHHlDbVXkMeta } from "/opt/build/repo/brands/timberland/pages/storelocator/footer.vue?macro=true";
import { default as headerlfoKwPNCV5Qw2H8HP1eFSHFJ7FLQfzbdFDKQCiF62vEMeta } from "/opt/build/repo/brands/timberland/pages/storelocator/header.vue?macro=true";
import { default as sitemapshYe80GseAi05MHEKQeFAvZg4_45XowIxUCEqgRJ7SvhIsMeta } from "/opt/build/repo/domains/core/pages/healthcheck/sitemaps.vue?macro=true";
import { default as indexy0zU_45IYBHh39fz8J8rTi3aFevijvP8TegUtudtmKmYIMeta } from "/opt/build/repo/domains/content/pages/sandbox/dialogs/index.vue?macro=true";
import { default as experiments6qbyACBWNmWPnV_45_45apu98dRknBGSrBo9y8Hkj6WB3B4Meta } from "/opt/build/repo/domains/core/pages/healthcheck/experiments.vue?macro=true";
import { default as newsletter_45subscriptionjY9j_4527bMA68p8KVehksl09vauQeoTwo49nP8SxsR8kMeta } from "/opt/build/repo/brands/timberland/pages/newsletter-subscription.vue?macro=true";
import { default as static_45pagesMx9rhWDKZc8W_ohSfghSSKROP3BZJZF7ako9gF1GrN8Meta } from "/opt/build/repo/domains/core/pages/healthcheck/static-pages.vue?macro=true";
import { default as translationscEY0wkIrJ0SyiL38JqfZLb9D_453zQUWB7HyQikvr2sbkMeta } from "/opt/build/repo/domains/core/pages/healthcheck/translations.vue?macro=true";
import { default as checkout4977_oSYx_45KkdBASNOMgaA6iXiukHnrMBCiE2Ud8y6cMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/checkout.vue?macro=true";
import { default as declaration_45of_45conformitysEogk5q8oxClv7z_1VEt2GYghyd68rsUwCO6BAkSUf4Meta } from "/opt/build/repo/brands/timberland/regions/emea/pages/declaration-of-conformity.vue?macro=true";
import { default as _91productId_93ZZv7WtSOGL4FJN33mtZJo4pOKuw9iNsIFpY1qg8DDRwMeta } from "/opt/build/repo/domains/commerce/pages/find-in-store/[productId].vue?macro=true";
import { default as feature_45flagsGBdTz8454P8O9IuSxO2DxwDKR2TogiLoaCYxaiklJGUMeta } from "/opt/build/repo/domains/core/pages/healthcheck/feature-flags.vue?macro=true";
import { default as qrcodeFxCAvL_7o4m7EYCogp0yxwJzh8FzI3s9PA468hab7BUMeta } from "/opt/build/repo/brands/timberland/regions/emea/pages/az-contest-in-store/qrcode.vue?macro=true";
import { default as uploadpuL8NE0lbDucalAxfq9woRsAhPam9kV3yVe_45IUsSEtwMeta } from "/opt/build/repo/brands/timberland/regions/emea/pages/az-contest-in-store/upload.vue?macro=true";
import { default as pro_45repositoryZ52zAhGxngK16W2_E6Ie_y_450zqIWkblUyunkbRavPoQMeta } from "/opt/build/repo/brands/timberland/pages/timberlandpro/pro-repository.vue?macro=true";
import { default as indexoYrVXXjg0mlX5Y2Q4acJlcR8IPQODllGPaBVT02i2LUMeta } from "/opt/build/repo/domains/core/pages/healthcheck/reports/a11y/index.vue?macro=true";
import { default as order_45shipment_45trackerG4zRtZ_jckRdFGc7t8Lz97C54Ou7TlXTq6LeD8GXOZEMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/order-shipment-tracker.vue?macro=true";
import { default as _91slug_93tbNTteD2bZUkkWcx8zQUR29XyjSYidPjOCuGBdidKMYMeta } from "/opt/build/repo/domains/core/pages/healthcheck/reports/a11y/[slug].vue?macro=true";
import { default as profile5owZybaWWjhlFsQIndADBH7YlGVAzjVUaOALQ_45LWKcIMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/account/profile.vue?macro=true";
import { default as dashboardRZixJzfWRPjqRr1LT21kVDXVKMN9vkgmbOfUTAZEwg8Meta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/account/dashboard.vue?macro=true";
import { default as order_45confirmationEK9aP7Mdxb7Ri0vCc0_459SmdNAhDnudR83VB9cLubHhoMeta } from "/opt/build/repo/domains/commerce/pages/sandbox/preview/order-confirmation.vue?macro=true";
import { default as indexWBh0e5c4DVA7hc_ye_R3u_Uo619uYtNuiIguTuM3F8QMeta } from "/opt/build/repo/domains/core/pages/healthcheck/reports/performance/index.vue?macro=true";
import { default as _91slug_93yBF8M_45BoCes_ms4m2AnPEZCs47idcQL_3u2spFycPXMMeta } from "/opt/build/repo/domains/core/pages/healthcheck/reports/performance/[slug].vue?macro=true";
export default [
  {
    name: "400",
    path: "/400",
    meta: _400nXinuWCnwbXaZs5Fxd8Bvo9FzXLNT1W9v0jTQlMR5RIMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/400.vue")
  },
  {
    name: "401",
    path: "/401",
    meta: _4014ArVz3GTOhpBztB4wIj7ToKB2D89motj214kE49_JLwMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/401.vue")
  },
  {
    name: "403",
    path: "/403",
    meta: _4032bwS6BTmJW_45SahbMB7cNEY1bIvHb7m8Qum5v77Qe1w0Meta || {},
    component: () => import("/opt/build/repo/domains/core/pages/403.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404FkvJYN2RR2_DK1I6DUQ7N7pM8KJl0dY5VeySMLfPtAEMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/404.vue")
  },
  {
    name: "500",
    path: "/500",
    meta: _500xF7TE5f1siBnPEZIyZ5iugifPB2Zl3jioKBLFZ69yOsMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/500.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: cartijX6008voCsjRaXrjozoJMBR24DaJtq4HBokuQXJlTsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/cart.vue")
  },
  {
    name: helpYI9Aj03_45GBus75FoIdry2HO3IzfvJCigBUfYzlPr7GEMeta?.name,
    path: "/help",
    meta: helpYI9Aj03_45GBus75FoIdry2HO3IzfvJCigBUfYzlPr7GEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/help.vue"),
    children: [
  {
    name: "help",
    path: "",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/index.vue")
  },
  {
    name: "help-all-topics",
    path: "all-topics",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/all-topics.vue")
  },
  {
    name: "help-contact-us",
    path: "contact-us",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/contact-us.vue")
  },
  {
    name: "help-size-chart",
    path: "size-chart",
    component: () => import("/opt/build/repo/brands/timberland/pages/help/size-chart.vue")
  },
  {
    name: "help-size-charts",
    path: "size-charts",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/size-charts.vue")
  },
  {
    name: "help-slug",
    path: ":slug()",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/[slug]/index.vue")
  },
  {
    name: "help-slug-child_slug",
    path: ":slug()/:child_slug()",
    component: () => import("/opt/build/repo/domains/commerce/pages/help/[slug]/[child_slug]/index.vue")
  },
  {
    name: "help-promotions-and-discounts-slug",
    path: "promotions-and-discounts/:slug()",
    component: () => import("/opt/build/repo/brands/timberland/pages/help/promotions-and-discounts/[slug].vue")
  }
]
  },
  {
    name: "search-parent",
    path: "/search",
    meta: { ...(searchRO4tzUI4tmQBu_aNiG_tC0A3rxzZdSwXd5dYKSaVXWkMeta || {}), ...{"middleware":"plp-store-filter"} },
    component: () => import("/opt/build/repo/domains/commerce/pages/search.vue"),
    children: [
  {
    name: "search",
    path: "",
    component: () => import("/opt/build/repo/domains/commerce/pages/search/index.vue")
  },
  {
    name: "search-articles",
    path: "articles",
    component: () => import("/opt/build/repo/domains/commerce/pages/search/articles.vue")
  }
]
  },
  {
    name: "stores",
    path: "/stores",
    component: () => import("/opt/build/repo/brands/timberland/pages/stores.vue")
  },
  {
    name: account_3j_45mcRuyGg7FTgtN0KIkS4xk9Jg96vrgdYuKT1i2F0Meta?.name,
    path: "/account",
    meta: account_3j_45mcRuyGg7FTgtN0KIkS4xk9Jg96vrgdYuKT1i2F0Meta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/account.vue"),
    children: [
  {
    name: "account",
    path: "",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/index.vue")
  },
  {
    name: "account-loyalty",
    path: "loyalty",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/loyalty.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/profile.vue")
  },
  {
    name: "account-gift-cards",
    path: "gift-cards",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/gift-cards.vue")
  },
  {
    name: "account-address",
    path: "address",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/address/index.vue")
  },
  {
    name: "account-order-history",
    path: "order-history",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/order-history.vue")
  },
  {
    name: "account-credit-cards-add",
    path: "credit-cards/add",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/credit-cards/add.vue")
  },
  {
    name: "account-credit-cards",
    path: "credit-cards",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/credit-cards/index.vue")
  },
  {
    name: "account-order-details-id",
    path: "order-details/:id(.*)*",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/order-details/[...id].vue")
  },
  {
    name: "account-address-add-billing-address",
    path: "address/add-billing-address",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/address/add-billing-address.vue")
  },
  {
    name: "account-address-add-shipping-address",
    path: "address/add-shipping-address",
    component: () => import("/opt/build/repo/domains/commerce/pages/account/address/add-shipping-address.vue")
  }
]
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45inU9qLdxmychjW0749cQjyNd9nXpwrQ_wZcKzTpjldOiEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/sign-in.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/opt/build/repo/brands/timberland/pages/about-us.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkout6zqv22aNu9BrG1dChQCj_455IH2kgAKnLezPye0Kugxm8Meta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/checkout.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93CrMFLkWbvVSiu0B9By5os_RsavVX2AgsroDUT_45TVRYwMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/[...slug].vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => import("/opt/build/repo/domains/commerce/pages/favorites.vue")
  },
  {
    name: "gift-card",
    path: "/gift-card",
    component: () => import("/opt/build/repo/domains/commerce/pages/gift-card.vue")
  },
  {
    name: "az-contest",
    path: "/az-contest",
    component: () => import("/opt/build/repo/brands/timberland/regions/emea/pages/az-contest.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/opt/build/repo/brands/timberland/pages/contact-us.vue")
  },
  {
    name: "lower-envs",
    path: "/lower-envs",
    meta: lower_45envsGva5dXm0sUdFEmvA3dbTcKFaQbJLUXZxYspbheLHck4Meta || {},
    component: () => import("/opt/build/repo/domains/core/pages/lower-envs.vue")
  },
  {
    name: "size-chart",
    path: "/size-chart",
    meta: size_45chartzkbOxfBx4qP_5TQivfBEla1g1Kz10ko2RWF6n5dcyssMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/size-chart.vue")
  },
  {
    name: "soci-frame",
    path: "/soci/frame",
    meta: frame1aSq_45MaS2HDfGNywXSkE_45CmCw_iZYPBIGgqFcUaenCsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/soci/frame.vue")
  },
  {
    name: "c-slug",
    path: "/c/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93EbK_vwv_l52SPLMC0fpbEeQDmT7O6fnDpyfDb6dFsqcMeta || {}), ...{"middleware":"plp-store-filter"} },
    component: () => import("/opt/build/repo/domains/commerce/pages/c/[...slug].vue")
  },
  {
    name: "cms-preview",
    path: "/cms/preview",
    meta: previewgT0SgvGgzxM32iVtPDlGsYEeL2DkQDkQKXFfkb64mgAMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/preview.vue")
  },
  {
    name: "o-slug",
    path: "/o/:slug(.*)*",
    component: () => import("/opt/build/repo/domains/brands/pages/o/[...slug].vue")
  },
  {
    name: "p-slug",
    path: "/p/:slug(.*)*",
    meta: _91_46_46_46slug_93sS_evXxzVeC_459iV85ESlWiWgprFUbbxSDUpIql4S_KsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/p/[...slug].vue")
  },
  {
    name: "soci-footer",
    path: "/soci/footer",
    meta: footerX44fL7pRNXwlmfhOZtBOvJUrLf94cvbG2VCFt6KjR94Meta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/soci/footer.vue")
  },
  {
    name: "soci-header",
    path: "/soci/header",
    meta: headerd3qY4igJYSD2pbxrvQmLpl7TfwNc5AQgrLVokWMCE1cMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/soci/header.vue")
  },
  {
    name: "get-the-look",
    path: "/get-the-look",
    component: () => import("/opt/build/repo/brands/timberland/pages/get-the-look.vue")
  },
  {
    name: "order-status",
    path: "/order-status",
    meta: order_45statuseng1bXoqVdZnkohFGOT_ZRQ_45Aunrz5i1gsBnoReHjvsMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/order-status.vue")
  },
  {
    name: "return-label",
    path: "/return-label",
    meta: return_45labelOejPaVcBEY8HeKLKvU94gqJgABWmpfQ4l1B6O7gP2ZEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/return-label.vue")
  },
  {
    name: "agent-results",
    path: "/agent-results",
    meta: agent_45resultsb7_45bqM4TqVCtAe8u2b0Gzmimq_45PkB3_45mHgEixcE0MNMMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/agent-results.vue")
  },
  {
    name: "order-details",
    path: "/order-details",
    meta: order_45detailsqZnQ8UGlraBim57iOR6Wi_L8uIHbpaKm_HubgRf7JZgMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/order-details.vue")
  },
  {
    name: "store-locator",
    path: "/store-locator",
    component: () => import("/opt/build/repo/domains/commerce/pages/store-locator.vue")
  },
  {
    name: "amazon-sign-in",
    path: "/amazon-sign-in",
    component: () => import("/opt/build/repo/domains/commerce/pages/amazon-sign-in.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password5V_454JzMUKSBahZIhy5iJTFfwBZCQEB9BJhWbfpKatwoMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/reset-password.vue")
  },
  {
    name: "social-sign-in",
    path: "/social-sign-in",
    component: () => import("/opt/build/repo/domains/commerce/pages/social-sign-in.vue")
  },
  {
    name: "write-a-review",
    path: "/write-a-review",
    component: () => import("/opt/build/repo/domains/commerce/pages/write-a-review.vue")
  },
  {
    name: "articles-slug",
    path: "/articles/:slug()",
    component: () => import("/opt/build/repo/domains/commerce/pages/articles/[slug].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/opt/build/repo/domains/commerce/pages/forgot-password.vue")
  },
  {
    name: "healthcheck",
    path: "/healthcheck",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/index.vue")
  },
  {
    name: "healthcheck-mocks",
    path: "/healthcheck/mocks",
    meta: mocksZVKZB7WOQCI_jPUqDbeA6yfCjux2UADwAFNk8M1FjdwMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/mocks.vue")
  },
  {
    name: "location-selector",
    path: "/location-selector",
    meta: location_45selectoruqLqoewvfbQiJh3XlRldlZt7EdDCHIWNDCuDY11AoYwMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/location-selector.vue")
  },
  {
    name: "payment-link-id",
    path: "/payment-link/:id()",
    component: () => import("/opt/build/repo/domains/core/pages/payment-link/[id].vue")
  },
  {
    name: "sandbox-cms",
    path: "/sandbox/cms",
    component: () => import("/opt/build/repo/domains/content/pages/sandbox/cms/index.vue")
  },
  {
    name: "cms-showcase-split",
    path: "/cms/showcase/split",
    meta: splitCZmeTn22XMqu8E3XE1btCyKFraULprQk5lP2eftDHjIMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/showcase/split.vue")
  },
  {
    name: "collections-slug",
    path: "/collections/:slug()",
    component: () => import("/opt/build/repo/brands/timberland/pages/collections/[slug].vue")
  },
  {
    name: "healthcheck-status",
    path: "/healthcheck/status",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/status.vue")
  },
  {
    name: "order-confirmation",
    path: "/order-confirmation",
    meta: order_45confirmationLAOHCUh_457ZAaowyQA723r4zI5jIYIqmcl0XAb3TXD9kMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/order-confirmation.vue")
  },
  {
    name: "cms-showcase-single",
    path: "/cms/showcase/single",
    meta: singlekivaXphvI_45xjWtJXWb8EP6_45kyuhXQhiG9mZgvZcVHJkMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/showcase/single.vue")
  },
  {
    name: "cms-showcase-viewer",
    path: "/cms/showcase/viewer",
    meta: viewerEq2MpXIuVkPkNABg4b64rG7cmF3Zb3XdR3OBFi3ZG6kMeta || {},
    component: () => import("/opt/build/repo/domains/content/pages/cms/showcase/viewer.vue")
  },
  {
    name: "product-ingredients",
    path: "/product-ingredients",
    component: () => import("/opt/build/repo/brands/timberland/pages/product-ingredients.vue")
  },
  {
    name: "reviews-productId",
    path: "/reviews/:productId()",
    meta: _91productId_93Zae_kquWzBWBEcyvwNdI1L41FELno9Qd7gD890BhSuMMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/reviews/[productId].vue")
  },
  {
    name: "storelocator-footer",
    path: "/storelocator/footer",
    meta: footerWxAjF2RgXBmZph4sum5AiHuMiXB6_mfvISnHHlDbVXkMeta || {},
    component: () => import("/opt/build/repo/brands/timberland/pages/storelocator/footer.vue")
  },
  {
    name: "storelocator-header",
    path: "/storelocator/header",
    meta: headerlfoKwPNCV5Qw2H8HP1eFSHFJ7FLQfzbdFDKQCiF62vEMeta || {},
    component: () => import("/opt/build/repo/brands/timberland/pages/storelocator/header.vue")
  },
  {
    name: "healthcheck-sitemaps",
    path: "/healthcheck/sitemaps",
    meta: sitemapshYe80GseAi05MHEKQeFAvZg4_45XowIxUCEqgRJ7SvhIsMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/sitemaps.vue")
  },
  {
    name: "sandbox-dialogs",
    path: "/sandbox/dialogs",
    component: () => import("/opt/build/repo/domains/content/pages/sandbox/dialogs/index.vue")
  },
  {
    name: "healthcheck-experiments",
    path: "/healthcheck/experiments",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/experiments.vue")
  },
  {
    name: "newsletter-subscription",
    path: "/newsletter-subscription",
    component: () => import("/opt/build/repo/brands/timberland/pages/newsletter-subscription.vue")
  },
  {
    name: "healthcheck-static-pages",
    path: "/healthcheck/static-pages",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/static-pages.vue")
  },
  {
    name: "healthcheck-translations",
    path: "/healthcheck/translations",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/translations.vue")
  },
  {
    name: "sandbox-preview-checkout",
    path: "/sandbox/preview/checkout",
    meta: checkout4977_oSYx_45KkdBASNOMgaA6iXiukHnrMBCiE2Ud8y6cMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/checkout.vue")
  },
  {
    name: "declaration-of-conformity",
    path: "/declaration-of-conformity",
    component: () => import("/opt/build/repo/brands/timberland/regions/emea/pages/declaration-of-conformity.vue")
  },
  {
    name: "find-in-store-productId",
    path: "/find-in-store/:productId()",
    meta: _91productId_93ZZv7WtSOGL4FJN33mtZJo4pOKuw9iNsIFpY1qg8DDRwMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/find-in-store/[productId].vue")
  },
  {
    name: "healthcheck-feature-flags",
    path: "/healthcheck/feature-flags",
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/feature-flags.vue")
  },
  {
    name: "az-contest-in-store-qrcode",
    path: "/az-contest-in-store/qrcode",
    meta: qrcodeFxCAvL_7o4m7EYCogp0yxwJzh8FzI3s9PA468hab7BUMeta || {},
    component: () => import("/opt/build/repo/brands/timberland/regions/emea/pages/az-contest-in-store/qrcode.vue")
  },
  {
    name: "az-contest-in-store-upload",
    path: "/az-contest-in-store/upload",
    component: () => import("/opt/build/repo/brands/timberland/regions/emea/pages/az-contest-in-store/upload.vue")
  },
  {
    name: "timberlandpro-pro-repository",
    path: "/timberlandpro/pro-repository",
    component: () => import("/opt/build/repo/brands/timberland/pages/timberlandpro/pro-repository.vue")
  },
  {
    name: "healthcheck-reports-a11y",
    path: "/healthcheck/reports/a11y",
    meta: indexoYrVXXjg0mlX5Y2Q4acJlcR8IPQODllGPaBVT02i2LUMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/reports/a11y/index.vue")
  },
  {
    name: "sandbox-order-shipment-tracker",
    path: "/sandbox/order-shipment-tracker",
    meta: order_45shipment_45trackerG4zRtZ_jckRdFGc7t8Lz97C54Ou7TlXTq6LeD8GXOZEMeta || {},
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/order-shipment-tracker.vue")
  },
  {
    name: "healthcheck-reports-a11y-slug",
    path: "/healthcheck/reports/a11y/:slug()",
    meta: _91slug_93tbNTteD2bZUkkWcx8zQUR29XyjSYidPjOCuGBdidKMYMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/reports/a11y/[slug].vue")
  },
  {
    name: "sandbox-preview-account-profile",
    path: "/sandbox/preview/account/profile",
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/account/profile.vue")
  },
  {
    name: "sandbox-preview-account-dashboard",
    path: "/sandbox/preview/account/dashboard",
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/account/dashboard.vue")
  },
  {
    name: "sandbox-preview-order-confirmation",
    path: "/sandbox/preview/order-confirmation",
    component: () => import("/opt/build/repo/domains/commerce/pages/sandbox/preview/order-confirmation.vue")
  },
  {
    name: "healthcheck-reports-performance",
    path: "/healthcheck/reports/performance",
    meta: indexWBh0e5c4DVA7hc_ye_R3u_Uo619uYtNuiIguTuM3F8QMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/reports/performance/index.vue")
  },
  {
    name: "healthcheck-reports-performance-slug",
    path: "/healthcheck/reports/performance/:slug()",
    meta: _91slug_93yBF8M_45BoCes_ms4m2AnPEZCs47idcQL_3u2spFycPXMMeta || {},
    component: () => import("/opt/build/repo/domains/core/pages/healthcheck/reports/performance/[slug].vue")
  }
]